import { useState } from "react";
import { IconButton, InputAdornment, TextField, Tooltip } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import Translate from "component/global/translation/translation-component";
import { PASSWORD_MASK } from "../services/passwordField";
import { SharedFieldInputProps } from "./types";

interface PasswordFieldInputProps extends SharedFieldInputProps<string | null> {
    masked?: boolean;
}

export function PasswordFieldInput({
    value,
    onChange,
    error = false,
    helperText,
    autoFocus = false,
    fullWidth = true,
    size = "small",
    disabled = false,
    masked = false,
}: PasswordFieldInputProps) {
    const [visible, setVisible] = useState(false);
    const [editing, setEditing] = useState(false);
    const shouldShowMask = masked && !editing && !value;
    const displayValue = shouldShowMask ? PASSWORD_MASK : value ?? "";

    const handleFocus = () => {
        if (shouldShowMask) {
            setEditing(true);
        }
    };

    return (
        <TextField
            value={displayValue}
            type={visible ? "text" : "password"}
            onFocus={handleFocus}
            onBlur={() => {
                if (!value) {
                    setEditing(false);
                }
            }}
            onChange={(event) => {
                setEditing(true);
                onChange(event.target.value);
            }}
            error={error}
            helperText={helperText}
            autoFocus={autoFocus}
            fullWidth={fullWidth}
            size={size}
            disabled={disabled}
            InputProps={{
                endAdornment: (
                    <InputAdornment position="end">
                        <Tooltip title={<Translate text={visible ? "Hide password" : "Show password"} />}>
                            <span>
                                <IconButton
                                    aria-label={visible ? "Hide password" : "Show password"}
                                    edge="end"
                                    size="small"
                                    disabled={disabled}
                                    onClick={() => setVisible((current) => !current)}
                                >
                                    {visible ? <VisibilityOffIcon fontSize="small" /> : <VisibilityIcon fontSize="small" />}
                                </IconButton>
                            </span>
                        </Tooltip>
                    </InputAdornment>
                ),
            }}
        />
    );
}
